import React, { FC } from 'react';
import { DropdownView } from './DropdownView';
import { PageView } from './PageView';

interface Props {
    isDropdown?: boolean;
}

export const NotificationsContent: FC<Props> = ({ isDropdown }) => (isDropdown ? <DropdownView /> : <PageView />);
